<template>
  <div class="v2-address-detail">
    <div class="v2-address-detail__grid">
      <div
        v-if="address.addressLine1"
        class="v2-address-detail__field"
      >
        <span class="v2-address-detail__label">Address Line 1</span>
        <span class="v2-address-detail__value">{{ address.addressLine1 }}</span>
      </div>
      <div
        v-if="address.addressLine2"
        class="v2-address-detail__field"
      >
        <span class="v2-address-detail__label">Address Line 2</span>
        <span class="v2-address-detail__value">{{ address.addressLine2 }}</span>
      </div>
      <div
        v-if="address.city"
        class="v2-address-detail__field"
      >
        <span class="v2-address-detail__label">City</span>
        <span class="v2-address-detail__value">{{ address.city }}</span>
      </div>
      <div
        v-if="address.country"
        class="v2-address-detail__field"
      >
        <span class="v2-address-detail__label">Country</span>
        <span class="v2-address-detail__value">{{ address.country }}</span>
      </div>
      <div
        v-if="address.zipcode"
        class="v2-address-detail__field"
      >
        <span class="v2-address-detail__label">Zipcode</span>
        <span class="v2-address-detail__value">{{ address.zipcode }}</span>
      </div>
      <div
        v-if="address.contactName"
        class="v2-address-detail__field"
      >
        <span class="v2-address-detail__label">Address Contact Name</span>
        <span class="v2-address-detail__value">{{ address.contactName }}</span>
      </div>
      <div
        v-if="address.contactNumber"
        class="v2-address-detail__field"
      >
        <span class="v2-address-detail__label">Address Contact Number</span>
        <span class="v2-address-detail__value">{{ address.contactNumber }}</span>
      </div>
      <div
        v-if="address.contactEmail"
        class="v2-address-detail__field"
      >
        <span class="v2-address-detail__label">Address Contact Email</span>
        <span class="v2-address-detail__value">{{ address.contactEmail }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'V2AddressDetail',
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-address-detail {
  padding: var(--v2-space-2) 0;

  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--v2-space-3);
  }

  &__field {
    display: flex;
    flex-direction: column;
    gap: var(--v2-space-0-5);
  }

  &__label {
    font-family: var(--v2-font-sans);
    font-size: 0.75rem;
    color: var(--v2-muted-foreground);
  }

  &__value {
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;
    color: var(--v2-foreground);
  }
}
</style>
